import { render, staticRenderFns } from "./security-panel.vue?vue&type=template&id=91ded7ac"
import script from "./security-panel.vue?vue&type=script&lang=js"
export * from "./security-panel.vue?vue&type=script&lang=js"
import style0 from "./security-panel.vue?vue&type=style&index=0&id=91ded7ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports